export { isVirtualElement } from '@fluentui/dom-utilities';
//# sourceMappingURL=isVirtualElement.js.map